import { ComponentStyles } from "types/common";

export const styles: ComponentStyles = {
  playerWrap: {
    position: "relative",
  },
};
